/** The natural size of a picture file, read by the browser. */
export interface ImageSize {
  width: number;
  height: number;
}

export const readImageSize = (file: File): Promise<ImageSize> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);
    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Unable to read picture dimensions'));
    };
    image.src = objectUrl;
  });
